/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2023-03-13 14:21:46
 * @LastEditors: zhubaodong
 * @LastEditTime: 2023-03-13 19:31:50
 */
import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 公开课落地页
const channel = () => import("@/views/activity/channel/index.vue");
const wxPay = () => import("@/views/activity/zhifu/wx/index.vue"); // 微信支付
const payIng = () => import("@/views/activity/zhifu/ing/index.vue"); // 支付中
const payLoad = () => import("@/views/activity/zhifu/load/index.vue"); // 新版支付中（直播加企微）
const payFail = () => import("@/views/activity/zhifu/fail/index.vue"); // 支付失败
const paySuccess = () => import("@/views/activity/zhifu/success/index.vue"); // 支付失败
const helpCenterDetail = () =>
  import("@/views/activity/helpCenterDetail/index.vue");
const helpCenter = () => import("@/views/activity/helpCenter/index.vue");
// 元旦抽奖活动
const fireworks = () => import("@/views/activity/fireworks/index.vue");

// 转介绍活动页
const introductionActivityPage = () =>
  import(
    /* webpackChunkName: "introductionActivityPage" */ "@/views/activity/introductionActivityPage/index.vue"
  );
// 转介绍活动-收货地址页
const address = () =>
  import(
    /* webpackChunkName: "address" */ "@/views/activity/introductionActivityPage/address/index.vue"
  );
// 转介绍活动-海报页
const poster = () =>
  import(
    /* webpackChunkName: "poster" */ "@/views/activity/introductionActivityPage/sharePoster/index.vue"
  );
// 我的奖励
const rewardIndex = () =>
  import(
    /* webpackChunkName: "reward" */ "@/views/activity/reward/index/index.vue"
  );
// 我的奖励
const rewardAddress = () =>
  import(
    /* webpackChunkName: "reward" */ "@/views/activity/reward/address/index.vue"
  );
// 登录
const login = () =>
  import(/* webpackChunkName: "login" */ "@/views/activity/login/index.vue");
// 滑块验证
const slideVerify = () =>
  import(
    /* webpackChunkName: "slideVerify" */ "@/views/activity/slideVerify/index.vue"
  );
// 获取openId
const getOpenId = () =>
  import(
    /* webpackChunkName: "getOpenId" */ "@/views/activity/getOpenId/index.vue"
  );

// 打开APP
const evokeapp = () =>
  import(
    /* webpackChunkName: "evokeapp" */ "@/views/activity/evokeapp/index.vue"
  );

// 更多活动
const more = () =>
  import(
    /* webpackChunkName: "moreActivity" */ "@/views/activity/more/index.vue"
  );
// 调查问卷
const questionnaire = () =>
  import(
    /* webpackChunkName: "questionnaire" */ "@/views/activity/questionnaire/index.vue"
  );

// 问卷结果
const answer = () =>
  import(
    /* webpackChunkName: "questionnaire" */ "@/views/activity/questionnaire/answerFinish.vue"
  );

// 21年四月份 限时抽奖活动
const luckyDraw = () =>
  import(
    /* webpackChunkName: "luckyDraw" */ "@/views/activity/luckyDraw/index.vue"
  );
const websiteMaintain = () =>
  import(
    /* webpackChunkName: "websiteMaintain" */ "@/views/activity/websiteMaintain/index.vue"
  );
const customerService = () =>
  import(
    /* webpackChunkName: "customerService" */ "@/views/activity/customerService/index.vue"
  );
//微信公众号授权登录
const weChatAuth = () =>
  import(
    /* webpackChunkName: "weChatAuth" */ "@/views/activity/weChatAuth/index.vue"
  );
//微信跳转1v1app内积分商城
const openAiCenterShop = () =>
  import(
    /* webpackChunkName: "openAiCenterShop" */ "@/views/activity/openAiCenterShop/index.vue"
  );
//教师节活动
const teacherDay = () =>
  import(
    /* webpackChunkName: "teacherDay" */ "@/views/activity/teacherDay/index.vue"
  );
//2025年教师节年度报告
const teachersDay = () =>
  import(
    /* webpackChunkName: "teachersDay" */ "@/views/activity/teachersDay/index.vue"
  );
//2026年教师节年度报告
const teacherDay2026 = () =>
  import(
    /* webpackChunkName: "teacherDay2026" */ "@/views/activity/teacherDay2026/index.vue"
  );
//小程序跳h5，token中转页，小程序跳转h5需token校验，
const miniProgramJump = () =>
  import(
    /* webpackChunkName: "miniProgramJump" */ "@/views/activity/miniProgramJump/index.vue"
  );
export default {
  path: "/activity",
  component: view,
  children: [
    {
      path: "channel/:id",
      component: channel
    },
    {
      path: "zhifu/wx",
      component: wxPay
    },
    {
      path: "zhifu/ing",
      component: payIng
    },
    {
      path: "zhifu/load",
      component: payLoad
    },
    {
      path: "zhifu/fail",
      component: payFail
    },
    {
      path: "zhifu/success",
      component: paySuccess
    },
    {
      path: "introductionActivityPage",
      component: introductionActivityPage
    },
    {
      path: "introductionActivityPage/address",
      component: address,
      name: "address"
    },
    {
      path: "introductionActivityPage/poster",
      component: poster
    },
    {
      path: "reward/index",
      component: rewardIndex
    },
    {
      path: "reward/address",
      component: rewardAddress
    },
    {
      name: "slideVerify",
      path: "slideVerify",
      component: slideVerify
    },
    {
      name: "login",
      path: "login",
      component: login
    },
    {
      path: "getOpenId",
      component: getOpenId
    },
    {
      name: "evokeapp",
      path: "evokeapp",
      component: evokeapp
    },
    {
      name: "more",
      path: "more",
      component: more
    },
    {
      name: "helpCenter",
      path: "helpCenter",
      component: helpCenter
    },
    {
      name: "helpCenterDetail",
      path: "helpCenterDetail",
      component: helpCenterDetail
    },
    {
      name: "questionnaire",
      path: "questionnaire",
      component: questionnaire
    },
    {
      name: "answer",
      path: "answer",
      component: answer
    },
    {
      name: "fireworks",
      path: "fireworks",
      component: fireworks
    },
    {
      name: "luckyDraw",
      path: "luckyDraw",
      component: luckyDraw
    },
    {
      name: "websiteMaintain",
      path: "websiteMaintain",
      component: websiteMaintain
    },
    {
      name: "customerService",
      path: "customerService",
      component: customerService
    },
    {
      name: "weChatAuth",
      path: "weChatAuth",
      component: weChatAuth
    },
    {
      name: "openAiCenterShop",
      path: "openAiCenterShop",
      component: openAiCenterShop
    },
    {
      name: "teacherDay",
      path: "teacherDay",
      component: teacherDay
    },
    {
      name: "teachersDay",
      path: "teachersDay",
      component: teachersDay
    },
    {
      name: "teacherDay2026",
      path: "teacherDay2026",
      component: teacherDay2026
    },
    {
      name: "miniProgramJump",
      path: "miniProgramJump",
      component: miniProgramJump
    }
  ]
};
